import { apiClient } from '@/api/client';
import { API_ENDPOINTS } from '@/api/endpoints';
import type {
  Token,
  UserLogin,
  UserCreate,
  UserResponse,
  ForgotPasswordRequest,
  ResetPasswordRequest,
  ChangePasswordRequest,
  ResendVerificationRequest,
} from '@/api/types';

export const authService = {
  login: (body: UserLogin) =>
    apiClient.post<Token>(API_ENDPOINTS.AUTH.LOGIN, body).then((r) => r.data),
  signup: (body: UserCreate) =>
    apiClient.post<UserResponse>(API_ENDPOINTS.AUTH.SIGNUP, body).then((r) => r.data),
  me: () => apiClient.get<UserResponse>(API_ENDPOINTS.AUTH.ME).then((r) => r.data),
  forgotPassword: (body: ForgotPasswordRequest) =>
    apiClient.post(API_ENDPOINTS.AUTH.FORGOT_PASSWORD, body).then((r) => r.data),
  resetPassword: (body: ResetPasswordRequest) =>
    apiClient.post(API_ENDPOINTS.AUTH.RESET_PASSWORD, body).then((r) => r.data),
  verifyEmail: (token: string) =>
    apiClient.post(API_ENDPOINTS.AUTH.VERIFY_EMAIL, { token }).then((r) => r.data),
  resendVerification: (body: ResendVerificationRequest) =>
    apiClient.post(API_ENDPOINTS.AUTH.RESEND_VERIFICATION, body).then((r) => r.data),
  changePassword: (body: ChangePasswordRequest) =>
    apiClient.post(API_ENDPOINTS.AUTH.CHANGE_PASSWORD, body).then((r) => r.data),
  deleteAccount: () => apiClient.delete(API_ENDPOINTS.AUTH.DELETE_ACCOUNT).then((r) => r.data),
  /** Update profile display preferences. Fields are independent — send only the
   *  one you're changing (display currency ISO-4217, and/or number_locale). */
  updatePreferences: (body: { display_currency?: string; number_locale?: string }) =>
    apiClient.patch<UserResponse>(API_ENDPOINTS.AUTH.PREFERENCES, body).then((r) => r.data),
};
